import { IServicePersonalInformation } from '@app/model/interfaces/IServicePersonalInformation';

export class StateWithholding {
  stateAdditionallWithholdingAmount: number;
  stateDependents: number;
  stateWithholding: string;
  alternateCalculationCode: string;

  constructor(data: IServicePersonalInformation) {
    this.stateAdditionallWithholdingAmount = data.stateAdditionallWithholdingAmount;
    this.stateDependents = data.stateDependents;
    this.stateWithholding = data.stateWithholding;
    this.alternateCalculationCode = data.alternateCalculationCode;
  }
}
